module.exports = __webpack_public_path__ + "fonts/SalesforceSans-Regular.401b32ddc80c4c66d0558df1bc202d9b.woff";